<template>
    <div v-if="usuario" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Usuário</h4>
        <router-link to="/configuracoes/usuarios">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="Dados do Usuário">
          <p><strong>Nome:</strong> {{ usuario.pessoa_fisica_nome || 'Não informado' }}</p>
          <p><strong>E-mail:</strong> {{ usuario.email }}</p>
          <p><strong>Perfil:</strong> {{ usuario.perfil_nome || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ usuario.is_active === true ? 'Sim' : 'Não' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>


<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      usuario: null,
    };
  },
  methods: {
    async carregarDetalhesUsuario() {
      try {
        const response = await axios.get(
          `/configuracoes/usuarios/${this.$route.params.id}`
        );
        this.usuario = response.data;

        // Carregar o nome da pessoa física associada
        if (this.usuario.pessoa_fisica_id) {
          await this.carregarNomePessoaFisica(this.usuario.pessoa_fisica_id);
        }
      } catch (error) {
        console.error("Erro ao carregar os detalhes do usuário:", error);
      }
    },

    async carregarNomePessoaFisica(pessoaFisicaId) {
      try {
        const response = await axios.get(
          `/cadastros/pessoas-fisicas/${pessoaFisicaId}`
        );
        this.usuario.pessoa_fisica_nome = response.data.nome;
      } catch (error) {
        console.error("Erro ao carregar o nome da pessoa física:", error);
        this.usuario.pessoa_fisica_nome = "Não encontrado";
      }
    },

    async carregarNomePerfil(profileId) {
      try {
        const response = await axios.get(
          `/configuracoes/perfis-de-usuarios/${profileId}`
        );
        this.usuario.perfil = response.data.nome;
      } catch (error) {
        console.error("Erro ao carregar o nome do perfil:", error);
        this.usuario.perfil = "Não encontrado";
      }
    },

  },
  mounted() {
    this.carregarDetalhesUsuario();
  },
};
</script>


<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}

.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}

.form-content {
  margin-top: 1.5rem;
}

button.btn-sm {
  padding: 6px 12px;
}
</style>
